import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import React from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import AboutPage from "./About";
import DocsPage from "./Docs";

function AppPage(props) {
    const { slug } = useParams();

    let pageElement = null;
    switch (slug) {
        case "about":
            pageElement = <AboutPage />;
            break;
        case "docs":
            pageElement = <DocsPage />;
            break;
        default:
            pageElement = <div>Page not found</div>;
    }

    return <MainBlock>{pageElement}</MainBlock>;
}

export default AppPage;
